import Vector2 from '../math/Vector2';
import Vector3 from '../math/Vector3';
import TRIANGLE_normal from '../faces/TRIANGLE_normal';

export default class QuadGeometry {
	positions: Array<Vector3>;
	normals: Array<Vector3>;
	uvs: Array<Vector2>;
	faces: Array<TRIANGLE_normal>;

	constructor () {
		const x0 = 0;
		const x1 = 1;
		const y0 = 0;
		const y1 = 1;
		const z = 0;

		this.positions = [
			new Vector3(x0, y0, z),
			new Vector3(x0, y1, z),
			new Vector3(x1, y0, z),
			new Vector3(x1, y1, z)
		];

		this.normals = [
			new Vector3(0, 0, 1)
		];

		const u0 = 0;
		const u1 = 1;
		const v0 = 0;
		const v1 = 1;

		this.uvs = [
			new Vector2(u0, v1),
			new Vector2(u0, v0),
			new Vector2(u1, v1),
			new Vector2(u1, v0)
		];

		this.faces = QuadGeometry.getFaces(0, 0);
	}

	static getFaces (positionOffset: number, normalOffset: number) {
		var p0 = positionOffset;
		var p1 = positionOffset + 1;
		var p2 = positionOffset + 2;
		var p3 = positionOffset + 3;

		var n = normalOffset;

		// Defining triangle counter-clockwise
		return [
			new TRIANGLE_normal(p2, p1, p0, n, n, n),
			new TRIANGLE_normal(p3, p1, p2, n, n, n)
		];
	}

}
